import Alert from "@mui/material/Alert";
import React from "react";

function ErrorMessage({ message }) {
  return <Alert severity="error">{message}</Alert>;
}

export default ErrorMessage;
